import React from 'react';
import PropTypes from 'prop-types';
import theme from './theme/theme';

function SelectorIcon({ asc, selected = false }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-tabler icon-tabler-selector"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      strokeWidth="2"
      stroke={theme.colors.gray['400']}
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <polyline
        points="8 9 12 5 16 9"
        stroke={selected && asc ? theme.colors.semantics.default : 'inherit'}
      />
      <polyline
        points="16 15 12 19 8 15"
        stroke={selected && !asc ? theme.colors.semantics.default : 'inherit'}
      />
    </svg>
  );
}

SelectorIcon.propTypes = {
  asc: PropTypes.bool,
  selected: PropTypes.bool,
};

export default SelectorIcon;
